import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SetStatusService = /** @class */ (function () {
    function SetStatusService(http) {
        this.http = http;
    }
    SetStatusService.prototype.setStatus = function (reportId, status) {
        var params = {
            status: status.toString()
        };
        var requestBody = JSON.stringify(status.toString());
        return this.http
            .put("reports/" + reportId + "/status/", requestBody, { headers: { 'Content-Type': 'application/json' } });
    };
    SetStatusService.ngInjectableDef = i0.defineInjectable({ factory: function SetStatusService_Factory() { return new SetStatusService(i0.inject(i1.HttpClient)); }, token: SetStatusService, providedIn: "root" });
    return SetStatusService;
}());
export { SetStatusService };
